import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import '../style.css';
import { Col } from 'react-bootstrap';
import TeamHealthScore from './teamHealthScores';
import TeamColumn from './teamColumns';
import PopupRegister from '../../Signup/PopupRegister';

function TeamCard(props) {
	const { user, teams, sportsName, dispatch, nbaPage } = props;
	const [showModal, setShowModal] = useState(false);

	const handleLinkClick = (e) => {
		if (!user?.login) {
		  e.preventDefault();
		  setShowModal(true)
		}
		 else if (user?.login && !user?.email_verified) {
			e.preventDefault();
			setShowModal(true);
		}
	};

	return (
		<React.Fragment>
			<PopupRegister 
				showModal={showModal} 
				setShowModal={setShowModal} 
				returnUrl={window.location.pathname + window.location.search}
			/>
			{teams &&
				teams.map((team, i) => (
					<Col id={team.team_id} lg={4} key={i} className='cardCol col-xl-5ths col-md-6 col-sm-6 col-xs-12' style={{ height: '300px' }}>
						<div className='cardColDiv'>
							<div className='cardSpreadDiv'>{user?.login ? <TeamHealthScore team={team} /> : <div style={{ padding: '27.5px 0' }} />}</div>
							{/* <TeamColumn team={team} userAllowed={user?.login} sportsID={user?.sportsID} /> */}
							<TeamColumn team={team} userAllowed={user?.login} sportsID={user?.sportsID} />
							<Col lg={12} className='cardViewGameCol'>
								<Link
									className='cardViewGameButton hover-delay'
									title='View Team'
									to={{
										pathname: `/${sportsName || 'nfl'}/team/${sportsName === 'cricket' ? team.master_team_id : team.team_id}`
									}}
									onClick={handleLinkClick}
								>
									{user?.login ? 'VIEW TEAM' : 'LOG IN OR JOIN FOR FREE'}								

								</Link>
							</Col>
						</div>
					</Col>
				))}
		</React.Fragment>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	schedules: state.schedules,
	match: state.match,
	user: state.user,
	purchasePlan: state.purchasePlan,
	sources: state.source
});

export default connect(mapStateToProps)(TeamCard);
